import template   from './my-rlink-model.html'
import controller from './my-rlink-model.controller'
import './my-rlink-model.styl'

let component = {
  restrict: 'E',
  bindings: {
    id: '@',
    type: '@',
    title: '@',
    model: '='
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration/my-rlink/my-rlink-model/my-rlink-model.component.js